import { useEffect } from "react";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";
import {
  LayoutDashboard, Search, KanbanSquare, GraduationCap, FileText, Plus, Building2,
  Users, CalendarClock, BarChart3, LifeBuoy, Package,
} from "lucide-react";

const ITEMS = [
  { label: "Go to Overview", to: "/", icon: LayoutDashboard },
  { label: "Discover jobs", to: "/discover", icon: Search },
  { label: "Add a job", to: "/discover?add=1", icon: Plus },
  { label: "Open Pipeline", to: "/pipeline", icon: KanbanSquare },
  { label: "Career Master", to: "/career", icon: GraduationCap },
  { label: "Resume Studio", to: "/resumes", icon: FileText },
  { label: "Companies", to: "/companies", icon: Building2 },
  { label: "Contacts", to: "/contacts", icon: Users },
  { label: "Interviews", to: "/interviews", icon: CalendarClock },
  { label: "Analytics", to: "/analytics", icon: BarChart3 },
  { label: "Help Center", to: "/help", icon: LifeBuoy },
];

export default function CommandPalette({ open, setOpen, navigate, isAdmin }) {
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen(true);
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [setOpen]);

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  const items = isAdmin ? [...ITEMS, { label: "Package & Download Center", to: "/admin/package", icon: Package }] : ITEMS;

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Type a command or search…" data-testid="command-palette-input" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigation & actions">
          {items.map((it) => (
            <CommandItem key={it.to} onSelect={() => go(it.to)} value={it.label}>
              <it.icon className="mr-2 h-4 w-4" />
              {it.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
